import { ClusterAutoscalerPoliciesV2 } from '@cast/types-cluster-autoscaler';

import { PoliciesList, PolicyKey } from 'types/policies';

export const getPoliciesList = (
  policies: ClusterAutoscalerPoliciesV2 | undefined
): PoliciesList => ({
  [PolicyKey.UnschedulablePods]: {
    label: 'Unscheduled pods policy',
    enabled: !!policies?.unschedulablePods?.enabled,
  },
  [PolicyKey.NodeDownscaler]: {
    label: 'Node deletion policy',
    enabled: !!policies?.nodeDownscaler?.emptyNodesEnabled,
  },
  [PolicyKey.ClusterLimits]: {
    label: 'CPU limit policy',
    enabled: !!policies?.clusterLimits?.enabled,
  },
});

export const CLUSTER_TOOLTIPS = {
  actionRequiresTerraform: 'To perform this action, please use Terraform',
};
